import React from 'react';
import { BaseDateRangeInput } from 'src/components/enterprise/components/BaseDateRangeInput/BaseDateRangeInput';
import { DATE_FORMAT } from 'src/components/DatePickerInput/DatePickerInput';
import { useInsightsDateRangeConstraints } from './hooks/useInsightsDateRangeConstraints';

interface InsightsDateRangeControlProps {
  name: string;
  id: string;
}

const DATE_PLACEHOLDER = DATE_FORMAT.toUpperCase();
const rules = {
  required: 'Date Range is required',
};

export const InsightsDateRangeControl: React.FC<InsightsDateRangeControlProps> =
  ({ name, id }) => {
    const { initialMonth, disabledDays } = useInsightsDateRangeConstraints();

    return (
      <BaseDateRangeInput
        id={id}
        name={name}
        ariaLabel="Insights Date Range"
        blockWidth
        placeholder={`${DATE_PLACEHOLDER}-${DATE_PLACEHOLDER}`}
        rules={rules}
        disabledDays={disabledDays}
        initialMonth={initialMonth}
      />
    );
  };
